export default __webpack_public_path__ + "static/media/green.28b3d343.svg";